import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DDIsService } from 'src/app/modules/users/_services/ddis.service';
import { DialPlansService } from '../../_services/dial-plans.service';
import { DDIsDetailComponent } from '../ddis-detail/ddis-detail.component';

@Component({
    selector: 'app-ddis-list',
    templateUrl: './ddis-list.component.html',
    styleUrls: ['./ddis-list.component.css'],
    host: { class: 'list-page' },
    standalone: false
})
export class DDIsListComponent implements OnInit {
  public ddis: any[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  public dialPlanNames: { [id: string]: string } = {};
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name')
  };

  constructor(
    public topbarService: TopbarService,
    private ddisService: DDIsService,
    private dialPlansService: DialPlansService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.topbarService.setTitle('DDIs');
    this.topbarService.addAction("Nuevo DDI", "pi pi-plus", false, () => this.edit(null));
    this.loadDialPlanNames();
  }

  async loadDialPlanNames() {
    const response = await firstValueFrom(this.dialPlansService.all({ page: { number: 1, size: 5000 }, sort: ['name'] }));
    this.dialPlanNames = {};
    response.data.forEach((p: any) => this.dialPlanNames[p.id] = p.name);
  }

  async loadData($event: any) {
    this.lastGridEvent = $event;
    this.loading = true;

    let params: IParamsCollection = {
      page: { number: $event.first / $event.rows + 1, size: $event.rows },
      sort: ['name'],
    };

    if (typeof $event.sortField != 'undefined') {
      params.sort = [($event.sortOrder > 0 ? '' : '-') + $event.sortField];
    }

    params.filter = FilterBuilder.fromObject(this.filters).build();

    try {
      const response = await firstValueFrom(this.ddisService.all(params));
      this.ddis = response.data;
      this.totalRecords = response.meta['total'];
      this.topbarService.setCount(this.totalRecords);
    } finally {
      this.loading = false;
    }
  }

  clearFilters() {
    this.filters.name.value = null;
    this.search();
  }

  search() {
    if (!this.lastGridEvent) return;
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(id: any) {
    const ref = this.dialogService.open(DDIsDetailComponent, {
      closable: true,
      modal: true,
      data: { id: id ? id : null },
      header: id ? 'Detalle del DDI' : 'Nuevo DDI',
      width: '50vw'
    });
    ref.onClose.subscribe(() => {
      this.loadDialPlanNames();
      this.loadData(this.lastGridEvent);
    });
  }

  delete(ddi: any) {
    this.confirmationService.confirm({
      message: '¿Está seguro que desea eliminar el DDI "' + ddi.name + '"?',
      header: 'Eliminar DDI',
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.ddisService.delete(ddi.id).subscribe({
          next: () => {
            this.messageService.add({ closable: true, severity: 'success', detail: 'DDI eliminado correctamente' });
            this.loadData(this.lastGridEvent);
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error?.error?.errors?.[0]?.title || error?.error?.title || 'No se puede eliminar el DDI.' });
          }
        });
      }
    });
  }
}
